import {
  textarea_styles_default
} from "./chunk.VRUJEYSK.js";
import {
  FormControl
} from "./chunk.HH2JJZ37.js";
import {
  l as l2
} from "./chunk.SQVLNLTX.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/textarea/textarea.ts
import { t as t2 } from "i18next";
var FadvTextarea = class extends FormControl {
  constructor() {
    super(...arguments);
    this.supportsBefore = false;
    this.supportsAfter = false;
    this.rows = 4;
    this.resize = "vertical";
    this.required = false;
    this.clearable = false;
    this.value = "";
    this.characterCount = false;
    this.currentCharacterCount = 0;
  }
  connectedCallback() {
    var _a;
    super.connectedCallback();
    this.handleSlotChange = this.handleSlotChange.bind(this);
    this.resizeObserver = new ResizeObserver(() => this.setTextareaHeight());
    (_a = this.shadowRoot) == null ? void 0 : _a.addEventListener("slotchange", this.handleSlotChange);
    this.handleSlotChange();
    this.updateComplete.then(() => {
      this.setTextareaHeight();
      this.updateCharacterCount();
      this.resizeObserver.observe(this.input);
    });
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.resizeObserver.unobserve(this.input);
  }
  focus(options) {
    this.input.focus(options);
  }
  blur() {
    this.input.blur();
  }
  select() {
    return this.input.select();
  }
  scrollPosition(position) {
    if (position) {
      if (typeof position.top === "number")
        this.input.scrollTop = position.top;
      if (typeof position.left === "number")
        this.input.scrollLeft = position.left;
      return void 0;
    }
    return {
      top: this.input.scrollTop,
      left: this.input.scrollTop
    };
  }
  setSelectionRange(selectionStart, selectionEnd, selectionDirection = "none") {
    return this.input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
  }
  setRangeText(replacement, start, end, selectMode = "preserve") {
    this.input.setRangeText(replacement, start, end, selectMode);
    if (this.value !== this.input.value) {
      this.value = this.input.value;
      emit(this, "sl-input");
    }
    if (this.value !== this.input.value) {
      this.value = this.input.value;
      this.setTextareaHeight();
      emit(this, "sl-input");
      emit(this, "sl-change");
    }
  }
  handleChange() {
    this.value = this.input.value;
    this.setTextareaHeight();
    emit(this, "sl-change");
  }
  handleDisabledChange() {
    if (this.input) {
      this.input.disabled = this.disabled;
    }
  }
  handleBlur() {
    this.hasFocus = false;
    this.input.placeholder = "";
    emit(this, "sl-blur");
  }
  handleFocus() {
    this.hasFocus = true;
    this.input.placeholder = !this.value && this.placeholder || "";
    emit(this, "sl-focus");
  }
  handleInput() {
    this.value = this.input.value;
    this.setTextareaHeight();
    emit(this, "sl-input");
  }
  handleRowsChange() {
    this.setTextareaHeight();
  }
  updateCharacterCount() {
    var _a, _b;
    if (!this.maxlength)
      return;
    if (!this.characterCount)
      return;
    this.currentCharacterCount = (_b = (_a = this.value) == null ? void 0 : _a.length) != null ? _b : 0;
  }
  setTextareaHeight() {
    if (this.input) {
      if (this.resize === "auto") {
        this.input.style.height = "auto";
        this.input.style.height = `${this.input.scrollHeight}px`;
      } else {
        this.input.style.height = void 0;
      }
    }
  }
  handleClearClick(event) {
    this.value = "";
    emit(this, "sl-clear");
    emit(this, "sl-input");
    emit(this, "sl-change");
    this.input.focus();
    event.stopPropagation();
  }
  renderClearable() {
    var _a;
    if (!this.clearable)
      return w;
    if (((_a = this.value) == null ? void 0 : _a.length) <= 0)
      return w;
    return $`<button aria-label=${t2("components:common.clearEntry")} part="clear-button" class="input__clear" type="button" @click=${this.handleClearClick} tabindex="-1" ><slot name="clear-icon"><fadv-icon name="circle-xmark" library="solid"></fadv-icon></slot></button>`;
  }
  handleClick() {
    if (this.disabled || this.hasFocus)
      return;
    this.focus();
  }
  renderBelow() {
    if (!this.maxlength)
      return w;
    if (!this.characterCount)
      return w;
    return $`<div class="textarea__char-count">${this.currentCharacterCount}/${this.maxlength}</div>`;
  }
  renderControl() {
    return $`<div part="base" class=${o({
      textarea: true,
      "textarea--resize-none": this.resize === "none",
      "textarea--resize-vertical": this.resize === "vertical",
      "textarea--resize-auto": this.resize === "auto",
      "form-control__control-host": true
    })} @click=${this.handleClick} >${this.renderFloatingLabel()}<textarea part="textarea" id=${this.inputId} class="form-control__control" name=${l(this.name)} .value=${l2(this.value || "")} ?disabled=${this.disabled} ?readonly=${this.readonly} ?required=${this.required} rows=${l(this.rows)} minlength=${l(this.minlength)} maxlength=${l(this.maxlength)} autocapitalize=${l(this.autocapitalize)} autocorrect=${l(this.autocorrect)} ?autofocus=${this.autofocus} spellcheck=${l(this.spellcheck)} inputmode=${l(this.inputmode)} aria-labelledby=${l(this.getLabelledBy())} @change=${this.handleChange} @input=${this.handleInput} @focus=${this.handleFocus} @blur=${this.handleBlur} ></textarea>${this.renderClearable()}</div>`;
  }
};
FadvTextarea.styles = [...FormControl.styles, textarea_styles_default];
__decorateClass([
  i(".form-control__control")
], FadvTextarea.prototype, "input", 2);
__decorateClass([
  e({ type: Number })
], FadvTextarea.prototype, "rows", 2);
__decorateClass([
  e()
], FadvTextarea.prototype, "resize", 2);
__decorateClass([
  e({ type: Number })
], FadvTextarea.prototype, "minlength", 2);
__decorateClass([
  e({ type: Number })
], FadvTextarea.prototype, "maxlength", 2);
__decorateClass([
  e()
], FadvTextarea.prototype, "pattern", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvTextarea.prototype, "required", 2);
__decorateClass([
  e()
], FadvTextarea.prototype, "autocapitalize", 2);
__decorateClass([
  e()
], FadvTextarea.prototype, "autocorrect", 2);
__decorateClass([
  e()
], FadvTextarea.prototype, "autocomplete", 2);
__decorateClass([
  e({ type: Boolean })
], FadvTextarea.prototype, "autofocus", 2);
__decorateClass([
  e({ type: Boolean })
], FadvTextarea.prototype, "spellcheck", 2);
__decorateClass([
  e()
], FadvTextarea.prototype, "inputmode", 2);
__decorateClass([
  e({ type: Boolean })
], FadvTextarea.prototype, "clearable", 2);
__decorateClass([
  e()
], FadvTextarea.prototype, "value", 2);
__decorateClass([
  e({ type: Boolean, attribute: "character-count" })
], FadvTextarea.prototype, "characterCount", 2);
__decorateClass([
  t()
], FadvTextarea.prototype, "currentCharacterCount", 2);
__decorateClass([
  watch("disabled")
], FadvTextarea.prototype, "handleDisabledChange", 1);
__decorateClass([
  watch("rows")
], FadvTextarea.prototype, "handleRowsChange", 1);
__decorateClass([
  watch("value")
], FadvTextarea.prototype, "updateCharacterCount", 1);
FadvTextarea = __decorateClass([
  n("fadv-textarea")
], FadvTextarea);

export {
  FadvTextarea
};
